<template>
    <div class="card-body">
        <div class="form">
            <div class="col-12">
                <label for="imagen">Imagen simpatizantes:</label>
                <p>
                    <small>
                        MEDIDAS: 1000X1200 - FORMATO: JPG 
                        <br>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.bg1_url">
                    <img :src="manager.bg1_url" style="max-height: 300px">
                    <br>
                    <Button class="mt-1" @click="imagenBorrada('bg1')">Borrar</Button>
                </template>
                <template v-else>
                    <vue-dropzone
                        ref="myVueDropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        v-on:vdropzone-success="imagenSubida('bg1', ...arguments)"
                        v-on:vdropzone-removed-file="imagenBorrada('bg1')"
                    ></vue-dropzone>
                </template>
            </div>
            <hr>
            <div class="col-12">
                <label for="imagen">Imagen renovación:</label>
                <p>
                    <small>
                        MEDIDAS: 1000X1200 - FORMATO: JPG - PNG
                        <br>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.bg2_url">
                    <img :src="manager.bg2_url" style="max-height: 300px">
                    <br>
                    <Button class="mt-1" @click="imagenBorrada('bg2')">Borrar</Button>
                </template>
                <template v-else>                                    
                    <vue-dropzone
                        ref="myVueDropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        v-on:vdropzone-success="imagenSubida('bg2', ...arguments)"
                        v-on:vdropzone-removed-file="imagenBorrada('bg2')"
                    ></vue-dropzone>
                </template>                                
            </div>
            <hr>
            <div class="col-12">
                <label for="imagen">Imagen principal:</label>
                <p>
                    <small>
                        MEDIDAS: 2000X1500 - FORMATO: JPG - PNG
                        <br>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.bg3_url">
                    <img :src="manager.bg3_url" style="max-height: 300px">
                    <br>
                    <Button class="mt-1" @click="imagenBorrada('bg3')">Borrar</Button>
                </template>
                <template v-else>
                    <vue-dropzone
                        ref="myVueDropzone"
                        id="dropzone"
                        :options="dropzoneOptionsBig"
                        v-on:vdropzone-success="imagenSubida('bg3', ...arguments)"
                        v-on:vdropzone-removed-file="imagenBorrada('bg3')"
                    ></vue-dropzone>
                </template>
            </div>
            <hr>
            <div class="col-12">
                <label for="imagen">Imagen login:</label>
                <p>
                    <small>
                        MEDIDAS: 2000X1500 - FORMATO: JPG - PNG
                        <br>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.bg4_url">
                    <img :src="manager.bg4_url" style="max-height: 300px">
                    <br>
                    <Button class="mt-1" @click="imagenBorrada('bg4')">Borrar</Button>
                </template>
                <template v-else>
                    <vue-dropzone
                        ref="myVueDropzone"
                        id="dropzone"
                        :options="dropzoneOptionsBig"
                        v-on:vdropzone-success="imagenSubida('bg4', ...arguments)"
                        v-on:vdropzone-removed-file="imagenBorrada('bg4')"
                    ></vue-dropzone>
                </template>
            </div>
            <hr>
            <div class="col-12" v-show="false">
                <label for="imagen">bg 5</label>
                <br>
                <template v-if="manager.bg5_url">
                    <img :src="manager.bg5_url" style="max-height: 300px">
                    <br>
                    <Button class="mt-1" @click="imagenBorrada('bg5')">Borrar</Button>
                </template>
                <template v-else>                                    
                    <vue-dropzone
                        ref="myVueDropzone"
                        id="dropzone"
                        :options="dropzoneOptionsBig"
                        v-on:vdropzone-success="imagenSubida('bg5', ...arguments)"
                        v-on:vdropzone-removed-file="imagenBorrada('bg5')"
                    ></vue-dropzone>
                </template>
            </div>
            <div class="col-12">
                <Button @click="guardarOpciones">Guardar</Button>
            </div>
        </div>
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    props: ['manager'],
    data() {
        return {
            dropzoneOptions: {
                url: this.config.API_BASE + '/upload/image?permisos=public&api_key=' + localStorage.getItem('token'),
                thumbnailWidth: 150,
                maxFilesize: 0.5,
                acceptedFiles: "image/png, image/jpeg",
                resizeHeight: 1200,
                resizeWidth: 1000,
                headers: { "My-Awesome-Header": "header value" },
                uploadMultiple: false,
                maxFiles: 1,
                addRemoveLinks: true
            },
            dropzoneOptionsBig: {
                url: this.config.API_BASE + '/upload/image?permisos=public&api_key=' + localStorage.getItem('token'),
                thumbnailWidth: 150,
                maxFilesize: 0.5,
                acceptedFiles: "image/png, image/jpeg",
                resizeHeight: 1500,
                resizeWidth: 2000,
                headers: { "My-Awesome-Header": "header value" },
                uploadMultiple: false,
                maxFiles: 1,
                addRemoveLinks: true
            },
        }
    },
    methods: {
        guardarOpciones() {
            this.$emit('guardar');
        },
        imagenBorrada(campo) {
            switch (campo) {
            case 'bg1':
                this.manager.bg1 = null;
                this.manager.bg1_url = null;
                break;
            case 'bg2':
                this.manager.bg2 = null;
                this.manager.bg2_url = null;
                break;
            case 'bg3':
                this.manager.bg3 = null;
                this.manager.bg3_url = null;
                break;
            case 'bg4':
                this.manager.bg4 = null;
                this.manager.bg4_url = null;
                break;  
            case 'bg5':
                this.manager.bg5 = null;
                this.manager.bg5_url = null;
                break;
            }
        },
        imagenSubida(campo, file, response) {
            switch (campo) {
            case 'bg1':
                this.manager.bg1 = response;
                break;
            case 'bg2':
                this.manager.bg2 = response;
                break;
            case 'bg3':
                this.manager.bg3 = response;
                break;
            case 'bg4':
                this.manager.bg4 = response;
                break;  
            case 'bg5':
                this.manager.bg5 = response;
                break;
            }
        }
    },
    components: {
        vueDropzone: vue2Dropzone
    }
}
</script>
